import Car from '@/components/manage/car';
import { menuTabIndexAtom } from '@/components/manage/commons/constants';
import Dest from '@/components/manage/dest';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow:hidden;

  padding: 1rem;
`;

export default function ManageTemplate() {
  const menuTabIndex = useAtomValue(menuTabIndexAtom);
  const [targetComp, setTargetComp] = useState<ReactElement>();

  useEffect(() => {
    switch (menuTabIndex) {
      case 1:
        setTargetComp(<Dest />);
        break;
      case 2:
        setTargetComp(<Car />);
        break;
      case 0:
      default:
        setTargetComp(<Dest />);
        break;
    }
  }, [menuTabIndex]);

  return <MainWrap>{targetComp}</MainWrap>;
}
